module.exports = __webpack_public_path__ + "static/media/Icone-Funcionario_Azul.fe0d140c.png";